import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  Cadastre,
  EstateError,
  EstateIdentity,
  EstateInformation,
  EstateState,
  OperationType,
} from "./estateInterfaces";

const initialState: EstateState = {
  estateInformation: {
    current: null,
    error: null,
    isLoading: false,
  },
  ownedEstateInformation: {
    current: null,
    error: null,
    isLoading: false,
  },
  ownedEstates: {
    current: null,
    error: null,
    isLoading: false,
  },
};

const estatesSlice = createSlice({
  name: "estates",
  initialState,
  reducers: {
    resetEstateInformation: (state) => {
      state.estateInformation.current = null;
      state.estateInformation.isLoading = false;
      state.estateInformation.error = null;
    },
    fetchEstateOnAddressStart: (
      state,
      _payload: PayloadAction<{
        addressId: number;
        recentlyBought?: boolean;
        onSuccess?: (estateInformation: EstateInformation) => void;
      }>,
    ) => {
      state.estateInformation.current = null;
      state.estateInformation.isLoading = true;
      state.estateInformation.error = null;
    },
    fetchEstateOnAddressSuccess: (
      state,
      payload: PayloadAction<EstateInformation>,
    ) => {
      state.estateInformation.current = payload.payload;
      state.estateInformation.isLoading = false;
      state.estateInformation.error = null;
    },
    fetchOwnedEstatesStart: (state) => {
      state.ownedEstates.isLoading = true;
      state.ownedEstates.error = null;
    },
    fetchhOwnedEstatesSuccess: (
      state,
      payload: PayloadAction<EstateIdentity[]>,
    ) => {
      state.ownedEstates.current = payload.payload;
      state.ownedEstates.isLoading = false;
      state.ownedEstates.error = null;
    },
    resetOwnedEstateInformation: (state) => {
      state.ownedEstateInformation.current = null;
      state.ownedEstateInformation.isLoading = false;
      state.ownedEstateInformation.error = null;
    },
    fetchOwnedEstateStart: (
      state,
      _payload: PayloadAction<{
        cadastre: Cadastre;
        onSuccess?: (estateInformation: EstateInformation) => void;
      }>,
    ) => {
      state.ownedEstateInformation.isLoading = true;
      state.ownedEstateInformation.error = null;
    },
    fetchOwnedEstateSuccess: (
      state,
      payload: PayloadAction<EstateInformation>,
    ) => {
      state.ownedEstateInformation.current = payload.payload;
      state.ownedEstateInformation.isLoading = false;
      state.ownedEstateInformation.error = null;
    },
    operationFailed: (state, payload: PayloadAction<EstateError>) => {
      switch (payload.payload.operationType) {
        case OperationType.GET_ESTATE:
          state.estateInformation.current = null;
          state.estateInformation.error = payload.payload;
          state.estateInformation.isLoading = false;
          break;
        case OperationType.GET_OWNED_ESTATES:
          state.ownedEstates.current = null;
          state.ownedEstates.error = payload.payload;
          state.ownedEstates.isLoading = false;
          break;
        case OperationType.GET_OWNED_ESTATE:
          state.ownedEstateInformation.current = null;
          state.ownedEstateInformation.error = payload.payload;
          state.ownedEstateInformation.isLoading = false;
          break;
      }
    },
  },
});

export const {
  fetchEstateOnAddressStart,
  fetchEstateOnAddressSuccess,
  fetchOwnedEstatesStart,
  fetchhOwnedEstatesSuccess,
  fetchOwnedEstateStart,
  fetchOwnedEstateSuccess,
  operationFailed,
  resetEstateInformation,
  resetOwnedEstateInformation,
} = estatesSlice.actions;
export const estate = estatesSlice.reducer;
